// Единый источник нормализации имени мерчанта для всех сравнений по имени
// (выбор шаблона, правила загрузки чека, брендинг).
//
// Имя `chcmanual` иногда приходит с кириллической «с» (U+0441) вместо латинской «c»
// (см. `getMerchantLogo` в utils.ts), а также с лишними пробелами и в разном регистре.
export const normalizeMerchant = (merchant?: string): string =>
  (merchant ?? '')
    .trim()
    .toLowerCase()
    .replace(/с/g, 'c'); // Cyrillic «с» → Latin «c»
